import React from "react";
import { useTranslation, Trans } from "react-i18next";
import MoodboardDownload from "./MoodboardDownload";

const dresscodeImages = [
  {
    src: "/images/dresscode1.jpg",
    alt: "90s outfit inspiration 1",
  },
  {
    src: "/images/dresscode2.jpg",
    alt: "90s outfit inspiration 2",
  },
  {
    src: "/images/dresscode3.jpg",
    alt: "90s outfit inspiration 3",
  },
  {
    src: "/images/dresscode4.jpg",
    alt: "90s outfit inspiration 4",
  },
];

const makeupImage = {
  src: "/images/makeup90s.jpg",
  alt: "90s makeup inspiration",
};

const gridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
  gap: "1rem",
};

const makeupImageContainerStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
};

const imageStyle: React.CSSProperties = {
  width: "100%",
  height: "auto",
  maxWidth: "300px",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
};

export default function DresscodeSection() {
  const { t } = useTranslation();

  return (
    <section style={{ padding: "2rem 1rem" }} id="dresscode">
      <h2 style={{ textAlign: "center", marginBottom: "1rem" }}>
        {t("dresscode.title")}
      </h2>

      <p
        style={{
          maxWidth: "700px",
          margin: "0 auto 2rem auto",
          textAlign: "center",
        }}
      >
        <Trans i18nKey="dresscode.text" components={{ bold: <strong /> }} />
      </p>

      <div style={gridStyle}>
        {dresscodeImages.map((img, index) => (
          <img
            key={index}
            src={img.src}
            alt={img.alt}
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            }}
          />
        ))}
      </div>
      <MoodboardDownload />
      <h3 style={{ textAlign: "center", marginTop: "3rem" }}>
        {t("dresscode.makeupTitle")}
      </h3>
      <p
        style={{
          maxWidth: "700px",
          margin: "0 auto 2rem auto",
          textAlign: "center",
        }}
      >
        <Trans
          i18nKey="dresscode.makeupText"
          components={{ bold: <strong /> }}
        />
      </p>
      <div style={makeupImageContainerStyle}>
        <img src={makeupImage.src} alt={makeupImage.alt} style={imageStyle} />
      </div>
    </section>
  );
}
